var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AbstractGetTask from '@vertical-plus/vue-js-api-platform/dist/model/task/abstract-get-task';
import Exception from '@vertical-plus/vue-js-api-platform/dist/model/exception/exception';
import Team from '../../entity/organisation/team';
export default class GetTeamsTask extends AbstractGetTask {
    run() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.execute();
            if (response.status === this.successCode) {
                const searchResults = this.parseSearchResults(response);
                const teams = [];
                for (const teamDto of searchResults.results) {
                    const dto = teamDto;
                    // Add member counts
                    dto.memberCount = (_d = (_c = (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a['hydra:meta']) === null || _b === void 0 ? void 0 : _b.memberCount) === null || _c === void 0 ? void 0 : _c[dto.id]) !== null && _d !== void 0 ? _d : 0;
                    dto.childCount = (_h = (_g = (_f = (_e = response.data) === null || _e === void 0 ? void 0 : _e['hydra:meta']) === null || _f === void 0 ? void 0 : _f.childCount) === null || _g === void 0 ? void 0 : _g[dto.id]) !== null && _h !== void 0 ? _h : 0;
                    // Add permissions
                    dto.readable = (_o = (_m = (_l = (_k = (_j = response.data) === null || _j === void 0 ? void 0 : _j['hydra:meta']) === null || _k === void 0 ? void 0 : _k.permissions) === null || _l === void 0 ? void 0 : _l[dto.id]) === null || _m === void 0 ? void 0 : _m.read) !== null && _o !== void 0 ? _o : false;
                    dto.editable = (_t = (_s = (_r = (_q = (_p = response.data) === null || _p === void 0 ? void 0 : _p['hydra:meta']) === null || _q === void 0 ? void 0 : _q.permissions) === null || _r === void 0 ? void 0 : _r[dto.id]) === null || _s === void 0 ? void 0 : _s.edit) !== null && _t !== void 0 ? _t : false;
                    dto.deletable = (_y = (_x = (_w = (_v = (_u = response.data) === null || _u === void 0 ? void 0 : _u['hydra:meta']) === null || _v === void 0 ? void 0 : _v.permissions) === null || _w === void 0 ? void 0 : _w[dto.id]) === null || _x === void 0 ? void 0 : _x.delete) !== null && _y !== void 0 ? _y : false;
                    teams.push(new Team(dto));
                }
                searchResults.results = teams;
                return searchResults;
            }
            switch (response.status) {
                case 401:
                    throw new Error(Exception.InvalidDetails);
                default:
                    throw new Error(Exception.UnknownError);
            }
        });
    }
    get url() {
        return '/teams';
    }
    get params() {
        if (!this.searchConditions) {
            return null;
        }
        return this.generateParamsFromData(this.searchConditions);
    }
}
//# sourceMappingURL=get-teams-task.js.map